const yellow100Color = '#FAF3D1';

export default yellow100Color;
